module.exports = __webpack_public_path__ + "static/media/16UNODC3.a414c627.jpg";